module.exports = __webpack_public_path__ + "static/media/professionalInfo.1414f568.svg";